import gravyAxios from "@/plugins/axios";

/***
 * clientsStore - module - contains clients specific state store
 * @type {any}
 */
const clientsStore = {
    state: () => ({
        clients: [],
        filteredClients: [],
        client: null,
    }),
    actions: {
        getClients: async ({commit}) => {
            let clients = await gravyAxios.get('/clients')
            commit('SET_CLIENTS', clients.data)
        },
        getClient: async ({commit}, clientId) => {
            let client = await gravyAxios.get('/client/' + clientId)
            commit('SET_CLIENT', client.data);
        },
        createClient: async ({commit}, client) => {
            let createdClient = await gravyAxios.post('/client', client)
            commit('NEW_CLIENT', createdClient.data);
        },
        updateClient: async ({commit}, client) => {
            let updatedClient = await gravyAxios.patch('/client', client)
            commit('SET_CLIENT', updatedClient.data)
        },
        deleteClient: async ({commit}, client) => {
            let deleteResults = await gravyAxios.delete('/client/' + client.id)

            commit('DELETE_CLIENT', client.id)
        },
        filterClients: ({commit}, clientNameString) => {
            commit('FILTER_CLIENTS', clientNameString)
        }
    },
    mutations: {
        SET_CLIENTS: (state, clients) => {
            state.clients = clients
            state.filteredClients = clients
        },

        GET_CLIENT: (state, clientId) => {
            const selectedClient = state.clients.find(client => client.id === +clientId);
            state.client = selectedClient;
        },

        DELETE_CLIENT: (state, clientId) => {
            const index = state.clients.findIndex(client => client.id === clientId);
            state.clients.splice(index, 1);
        },

        SET_CLIENT: (state, client) => {
            state.client = client;
        },

        NEW_CLIENT: (state, client) => {
            state.clients = [...state.clients, client];
        },
        FILTER_CLIENTS: (state, clientSearchString) => {
            let searchArray = []
            state.clients.forEach(client => {
                client.name.toLowerCase().includes(clientSearchString.toLowerCase()) ? searchArray.push(client) : null

            })


            searchArray.length > 0 ? state.filteredClients = searchArray : state.filteredClients = []
        },
        resetActiveClient: state => {
            state.client = null
        }

    },
    getters: {
        getClients: state => {
            return state.clients
        },
        getFilteredClients: state => {
            return state.filteredClients
        },
        getClient: state => {
            return state.client
        }
    }
}

export default clientsStore
